<template>
    <section class="hero is-fullheight">
        <div class="hero-head">
            <commemoria-navbar></commemoria-navbar>
            <div class="container is-fluid">
                <header class="level" style="margin-top: 15px; margin-bottom: 5px;">
                    <!-- Left side -->
                    <div class="level-left is-flex-shrink-1 is-clipped">
                        <div class="level-item">
                            <p class="title" style="font-size: 1.5rem;">
                                Contextualisation des lignes du temps
                            </p>
                        </div>
                    </div>

                    <!-- Right side -->
                    <div class="level-right" v-if="!loading">
                        <div class="level-item">
                            <b-tooltip label="Modifier" type="is-dark" position="is-bottom">
                                <button class="button is-light" @click="configurePresentationModal">
                                    <span class="icon is-small">
                                        <i class="fa fa-cog fa-lg" aria-hidden="true"></i>
                                    </span>
                                </button>
                            </b-tooltip>
                        </div>
                        <div class="level-item">
                            <button class="button is-primary" slot="trigger" @click="startFullscreen">
                                <span>Lancer la présentation</span>
                            </button>
                        </div>
                    </div>
                </header>
            </div>
        </div>
        <div class="hero-body" style="padding: 0.5rem 0;">
            <div class="container is-fluid has-text-centered" style="display: flex; flex-direction: column; max-width: calc(100vw - 64px);">
                <div id="presentation" class="box" style="height: 80vh; justify-content: center; align-items: center; display: flex; padding: 0;" v-show="!loading">
                    <div class="presentation-container" style="height: 100%; width: 100%; padding: 10px;">
                        <swiper :options="swiperOption" ref="swiper">

                            <!-- Title slide -->
                            <swiper-slide>
                                <title-slide :name="name" :description="description" :timelines="timelines"></title-slide>
                            </swiper-slide>

                            <!-- Events -->
                            <template v-for="event in events">
                                <template v-if="settings.showAllMedias && event.medias.length > 1">
                                    <template v-for="media in event.medias">
                                        <swiper-slide :key="'media-' + media.id">
                                            <media-slide :event="event" :media="media" :contextualization="true"></media-slide>
                                        </swiper-slide>
                                    </template>
                                </template>
                                <template v-else>
                                    <swiper-slide :key="'event-' + event.id">
                                        <event-slide :event="event" :contextualization="true"></event-slide>
                                    </swiper-slide>
                                </template>
                            </template>

                            <!-- Pagination -->
                            <div class="swiper-pagination" slot="pagination" @click="showList" style="font-size: 0.875rem; bottom: 0px; cursor: pointer;"></div>

                            <!-- Navigation arrows -->
                            <div class="swiper-button-prev" slot="button-prev"></div>
                            <div class="swiper-button-next" slot="button-next"></div>
                        </swiper>

                        <!-- Event list -->
                        <div v-show="list == true" style="width: 100%; height: 100%; position: absolute; top: 0; z-index:20; overflow: hidden; overflow-y: scroll; user-select: none; background-color: #fff;">
                            <ul class="timeline">
                                <li class="timeline-item" v-for="event in events" style="padding-bottom: 0.5rem;">
                                    <div class="timeline-marker" :class="'is-'+event.timeline.color" @click="goToSlideForEvent(event)" style="cursor: pointer;"></div>
                                    <div class="timeline-content" style="padding-top: 0.85em; width: 100%; text-align: left;">
                                        <div class="level" style="margin-bottom: 0;">
                                            <div class="level-left">
                                                <div class="level-item">
                                                    <span style="color: #365f79; cursor: pointer;" :class="slidesForEvent(event).includes(getRealIndex()) ? 'font-bold' : 'font-normal'" @click="goToSlideForEvent(event)">
                                                        {{ event.title }}
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="level-right">
                                                <div class="level-item">
                                                    <b-tag :type="'is-'+event.timeline.color" style="margin-left: 20px;">{{ event.timeline.title }}</b-tag>
                                                </div>
                                            </div>
                                        </div>
                                        <p style="font-style: italic; font-size: 11px;">
                                            <span>{{ format_date(event.start) }}</span>
                                            <template v-if="event.end">
                                                <span>&nbsp;&mdash;&nbsp;</span>
                                                <span>{{ format_date(event.end) }}</span>
                                            </template>
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="hero-foot">
            <commemoria-footer></commemoria-footer>
        </div>
        <b-loading :active.sync="loading"></b-loading>
    </section>
</template>

<script>

import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import eventSlide from '../presentation/event-slide'
import titleSlide from './title-slide'
import mediaSlide from '../presentation/media-slide'

function getTimelineColor(timeline, timelines) {
    return timelines.filter(function (el) {
       return el.id === timeline.id;
    })[0].color;
}

export default {
    components: {
        swiper,
        swiperSlide,
        eventSlide,
        titleSlide,
        mediaSlide
    },

    data() {
        return {
            swiperOption: {
                keyboard: {
                    enabled: true,
                },
                mousewheel: true,
                grabCursor: true,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction'
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },
            fullscreen: false,
            events: [],
            timeline: {
                title: ''
            },
            settings: {
                showAllMedias: false
            },
            list: false,
            name: '',
            description: '',
            loading: true,
            timelines: [],
        }
    },

    computed: {
        swiper() {
            return this.$refs.swiper.swiper
        }
    },

    methods: {
        fetchData() {

            var timelines = this.$store.getters.contextualizationTimelines;

            if (timelines.length >= 2) {
                this.loading = true;
                var ids = [];

                timelines.forEach(function(timeline) {
                    ids.push(timeline.id);
                });

                axios.post('/api/v1/contextualizations?include=events.medias', {
                    'timelines': ids
                }).then(response => {
                    if (response.data.contextualization.name) {
                        this.name = response.data.contextualization.name;
                    }
                    if (response.data.contextualization.description) {
                        this.description = response.data.contextualization.description;
                    }
                    this.timelines = response.data.contextualization.timelines;

                    this.timelines.forEach(function(timeline, index, array) {
                        let colors = ['context1', 'context2', 'context3', 'context4'];
                        timeline.color = colors[index];
                    });

                    this.events = response.data.contextualization.events;

                    this.events = _.filter(this.events, {status: 'published'});

                    this.events.forEach(function(event,index) {
                        event.timeline.color = getTimelineColor(event.timeline, this.timelines);

                        event.medias = _.filter(event.medias, function(media) {
                            var type = media.type.split('/', 1);

                            if (type == 'image') {
                                return true;
                            }

                            if (type == 'video') {
                                return true;
                            }

                            return false;
                        });
                    }, this);

                    this.loading = false;

                }).catch(response => {
                        this.$buefy.toast.open({
                            message: 'Une erreur s\'est produite',
                            type: 'is-danger'
                        });
                        this.loading = false;
                });
            } else {
                this.loading = false;
            }
        },

        startFullscreen () {
            this.$fullscreen.toggle(this.$el.querySelector('.presentation-container'), {
                wrap: false,
                callback: this.fullscreenChange
            })
        },

        fullscreenChange (fullscreen) {
            this.fullscreen = fullscreen;
            this.swiper.update();
        },

        configurePresentationModal() {
            this.$buefy.modal.open({
                parent: this,
                props: {
                        settings: this.settings,
                },
                component: require('../../modals/configurePresentation').default,
                hasModalCard: true
            });
        },

        updateSettings (settings) {
            this.settings = settings;
            this.swiper.update();
            this.swiper.slideTo(0, 0, false);
        },

        showList() {
            this.list = true;
        },

        getRealIndex() {
            if (this.$refs.swiper) {
                return this.swiper.realIndex;  
            }

            return '0';
        },

        goToSlideForEvent(event) {
            var position = this.findSlidePositionForEvent(event);

            this.list = false;
            this.swiper.slideTo(position);
        },

        findSlidePositionForEvent(event) {

            var position = 1;

            for (let e of this.events) {
                if (e.id === event.id) {
                    break;        
                }

                position = position + 1;
                
                if (this.settings.showAllMedias && e.medias.length > 1) {
                    position = position + e.medias.length - 1;
                }
            }

            return position;
        },

        slidesForEvent(event) {

            var position = 1;

            var slides = [];

            for (let e of this.events) {

                if (e.id === event.id) {
                    slides.push(position);

                    if (this.settings.showAllMedias && e.medias.length > 1) {
                        for (var i = 1; i <= e.medias.length - 1; i++) {
                            slides.push(position+i);
                        }
                    }

                    break;        
                }

                position = position + 1;

                if (this.settings.showAllMedias && e.medias.length > 1) {
                    position = position + e.medias.length - 1;
                }
                
            }

            return slides;
        }
    },

    created() {
        this.fetchData();
        Bus.$on('updateSettings', (settings) => this.updateSettings(settings));
    },

    destroyed() {
        Bus.$off('updateSettings');
    },

    breadcrumb() {
        return {
            label: 'Contextualisation des lignes du temps',
            parent: 'home'
        }
    }
}
</script>

<style>
    .swiper-button-prev, .swiper-container-rtl .swiper-button-next {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23365F79'%2F%3E%3C%2Fsvg%3E");
        left: 20px;
        right: auto;
    }

    .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23365F79'%2F%3E%3C%2Fsvg%3E");
        right: 20px;
        left: auto;
    }

    .swiper-container {
        width: 100%;
        height: 100%;
    }

    .swiper-slide {
        text-align: center;
        display: flex;
        flex-grow: 1;
        background-position: center;
        background-size: cover;
        background-color: white;
    }

    .timeline .timeline-item::before {
        content: "";
        background-color: #dbdbdb;
        display: block;
        width: 0.1em;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }

    .timeline .timeline-item {
        margin-right: 1em;
    }

    .font-bold {
        font-weight: 700;
    }

    .font-normal {
        font-weight: 400;
    }
</style>